export default "__VITE_ASSET__26fdeb48__"